import { ButtonProps } from "@chakra-ui/react";
import {
  AccountAccessRole,
  AccountAccessRoleName,
} from "@syla/shared/types/models/AccountAccessBase";
import React from "react";
import { StandardSelectOption } from "../../components/selector/parts/SelectOption";
import { SingleSelector } from "../../components/selector/SingleSelector";

export const AccountAccessRoleDescription: Record<AccountAccessRole, string> = {
  [AccountAccessRole.Owner]: "Full control of account.",
  [AccountAccessRole.Administrator]:
    "Can change account settings and invite new members.",
  [AccountAccessRole.Accountant]:
    "Can change account settings and invite new members.",
  [AccountAccessRole.Editor]:
    "Cannot invite new members or manage the subscription.",
};

export const AccountAccessRoleOptions: StandardSelectOption<AccountAccessRole>[] =
  Object.values(AccountAccessRole).map((role) => ({
    value: role,
    data: {
      label: AccountAccessRoleName[role],
      description: AccountAccessRoleDescription[role],
    },
  }));

export function AccountAccessRoleSelector({
  currentRole,
  onSelected,
  isLoading,
  ...props
}: {
  currentRole: AccountAccessRole;
  onSelected: (role: AccountAccessRole) => void;
  isLoading?: boolean;
} & ButtonProps) {
  return (
    <SingleSelector
      options={AccountAccessRoleOptions}
      value={currentRole}
      onChange={onSelected}
      isLoading={isLoading}
      buttonProps={props}
    />
  );
}
